import React, { useEffect, useState } from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { getSocieteByUser } from '../../../../services/RHService/ContractService';
import getCurrentUserId from '../../../../reduxSaga/sagas/requests/currentUserId';
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: 'white',

  },
  section: {
    margin: 10,
    padding: 20,
    flexGrow: 1
  },
  title: {
    fontSize: 24,
    marginBottom: 10,
    textAlign: 'center'
  },
  text: {
    font: 'times new roman',
    fontSize: 14,
    marginBottom: 5,
    fontWeight: 'bold',
    textAlign: 'center'
  },

  text1: {
    font: 'times new roman',
    fontSize: 12,
    marginTop: 20,

  },
  text2: {
    font: 'times new roman',
    fontSize: 12,
    marginTop: 5,
  },
  text3: {
    font: 'times new roman',
    fontSize: 12,
    marginTop: 5,
    textDecoration: 'underline',
  },
  text4: {
    font: 'times new roman',
    fontSize: 12,
    marginTop: 20,
    fontWeight: 'bolder'
  },

  text5: {
    fontWeight: 'bold',
    textAlign: 'center',
    font: 'times new roman',
    fontSize: 12,
    marginTop: 20,
  },
  text6: {
    fontWeight: "bold",
    textAlign: "left",
    fontSize: 12,
    marginTop: 20,

  },
  text7: {
    fontWeight: 'bold',
    marginLeft: 100,
    fontSize: 12,
  },


  table: {
    display: 'table',
    width: 'auto',
    marginTop: 10,
    marginBottom: 10,
    borderStyle: 'normal',
    borderWidth: 0,
    borderColor: '#000',
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableCell: {
    width: '33.33%',
    borderStyle: 'normal',
    borderWidth: 1,
    borderColor: '#000',
    padding: 5,
    fontSize: 12
  },
  headerCell: {
    backgroundColor: 'white',
    fontSize: 12
  },
  headerText: {
    fontWeight: 'normal',
    fontSize: 12
  },
  cellText: {
    textAlign: 'center',
  },
  text11: {
    color: "#750000"
  }
});

function PDFGenerator(props) {
  const [societeDetail, setSocieteDetail] = useState(null);

  const contratDePartage = props.contratDePartage;
  const dateDeb = new Date(contratDePartage.dateDeb); // ensure date objects are used
  const dateFin = new Date(contratDePartage.dateFin);
  const timeDiff = dateFin.getTime() - dateDeb.getTime();
  const dayDiff = timeDiff / (1000 * 3600 * 24);
  const montantRetenue = (contratDePartage.totCharge * 10) / 100;
  const montantNet = contratDePartage.totCharge - montantRetenue;
 const fetchDataSociete = async () => {
    try {
      const response = await getSocieteByUser(getCurrentUserId());
      setSocieteDetail(response.data.success);
      console.log(response.data);
    } catch (error) {
      // setError(error.message);
    } finally {
      // setIsLoading(false);
    }
  };

    useEffect(() => {
      // fetchDataIsExistContract();
       fetchDataSociete();
    }, []);
  const headers = ['MONTANT NET', 'MONTANT DE RETENUE 10%'];
  const data = [{
    'MONTANT NET': contratDePartage ? contratDePartage.totCharge : '',
    'MONTANT DE RETENUE 10%': montantRetenue,
  }];
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.text} >CONTRAT DE PARTGE D’ACTION A DUREE DETERMINEE</Text>

          <Text style={styles.text1}> Le présent contrat est conclu entre les deux parties signataires ci-après :</Text>
          <Text style={styles.text2}>La société {societeDetail? societeDetail?.title:""} à responsabilité limitée, dont le siège social est à {societeDetail? societeDetail?.adresse:""} représentée par son gérant Mr/Mme {societeDetail? societeDetail?.representant:""} ; ci-après désignée en sa qualité d’« employeur » d’une part ,</Text>
          <Text style={styles.text2}><Text style={styles.text11}> Madame/Monsieur </Text>, {contratDePartage ? contratDePartage.nomBenif : ''} ,
            de nationalité <Text style={styles.text11}>TUNISIEN(NE) </Text>
            , ci-après
            désigné en sa qualité de « partage d’action » d’autre part.</Text>
          <Text style={styles.text4}>Il a été convenu ce qui suit :</Text>
          <Text style={styles.text3}>ARTICLE 1-Recrutement :</Text>

          <Text style={styles.text4}>la SOCIETE {societeDetail? societeDetail?.title:""} recrute provisoirement et temporairement <Text style={styles.text11}> Madame/Monsieur </Text>
            {contratDePartage ? contratDePartage.nomBenif : ''} en qualité de acteur ou actrice.
          </Text>
          <Text style={styles.text3}>
            ARTICLE 2 - Durée de contrat :</Text>
          <Text style={styles.text4}>Le présent contrat est conclu pour une durée de :  {dayDiff ? dayDiff : ''} jours, commençant le {contratDePartage ? contratDePartage.dateDeb : ''}  et finissant le {contratDePartage ? contratDePartage.dateFin : ''}  .</Text>
          <Text style={styles.text3}>ARTICLE 4 – Rémunération :</Text>

          <Text style={styles.text4}>En contre partie de cette action, L’acteur percevra une
            rémunération brute de  {contratDePartage ? contratDePartage.totCharge : ''}   dinars par action et soumis a une déduction d’une retenue à la source 10%.
          </Text>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              {headers.map((header, index) => (
                <View key={index} style={[styles.tableCell, styles.headerCell]}>
                  <Text style={styles.headerText}>{header}</Text>
                </View>
              ))}
            </View>
            {data.map((row, index) => (
              <View key={index} style={styles.tableRow}>
                {Object.values(row).map((cell, index) => (
                  <View key={index} style={styles.tableCell}>
                    <Text style={styles.cellText}>{cell}</Text>
                  </View>
                ))}
              </View>
            ))}
          </View>
          <Text style={styles.text3}>  ARTICLE 5- Conditions d’exécution du contrat :</Text>
          <Text style={styles.text4}>       L’acteur s’engage de façon formelle d'observer toutes les instructions et consignes particulières de travail qui lui seront données de tenir au secret professionnel dont il pourrait prendre connaissance à l'occasion de l'exercice de ses fonctions -
            doit veuiller au respect de l'horaire de travail, de ses supérieurs hiérarchiques et en général du règlement
            interne de la société.</Text>

          <Text style={styles.text4}>
            Le présent contrat est établi en deux exemplaires dont l’un devra être retourné signer à l’employeur. </Text>
          <Text></Text>
          <Text style={styles.text5}>Fait à Sousse le ..../../.. ,</Text>
          <Text style={styles.text4}><Text style={styles.text6}>Signature et cachet de l'employeur</Text>  <Text style={styles.text7}>            </Text>  <Text style={styles.text7}>                  </Text> <Text style={styles.text7}>Signature légalisée
            de l'acteur ou l'actrice</Text>  </Text>

        </View>
      </Page>
    </Document>
  );
}

export default PDFGenerator;